---
title: 'Step 1: Create Monitoring User'
install_track_title: Installation Guide (Google Cloud SQL and AlloyDB)
backlink_href: /docs/install
backlink_title: 'Installation Guide'
---

import TabPanel, {Tab} from '../../components/TabPanel'
import CreateMonitoringUserPsql from './_01_create_monitoring_user_psql.mdx'
import CreateMonitoringUserIam from './_01_create_monitoring_user_iam.mdx'

We recommend creating a separate monitoring user on your PostgreSQL database for pganalyze.

## Enabling pg_stat_statements

Connect to your database with **cloudsqlsuperuser / alloydbsuperuser** privileges (i.e. the initial user that was created on instance creation), e.g. using `psql`.

Run the following SQL commands to enable the `pg_stat_statements` extension, and make sure it was installed correctly:

```sql
CREATE EXTENSION IF NOT EXISTS pg_stat_statements;
SELECT * FROM pg_stat_statements LIMIT 1;
```

## Create monitoring user

You can either create a monitoring user manually using psql, or create a service account and use IAM authentication.

<TabPanel>
  <Tab id="psql" label="Manually with psql" textContent>
    <CreateMonitoringUserPsql />
  </Tab>
  <Tab id="iam" label="IAM Authentication" textContent>
    <CreateMonitoringUserIam />
  </Tab>
</TabPanel>

---

Next we continue by installing the pganalyze collector:

<Link className="btn btn-success" to="02_install_the_collector">
  Proceed to Step 2: Install the collector
</Link>
